import React from 'react';
import {
  Button,
  Select,
  SelectOption,
  Spacing,
  StyledDiv,
  TitleText,
  Typography,
} from '@taleemabad/dsm/components';
import styled from '@emotion/styled';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

export interface UGEGSelectQuestionTypeProps {
  titleLeftText: string;
  titleRightText: string;
  selectedQuestionType: SelectOption | null;
  onQuestionTypeChange: (option: SelectOption) => void;
  onNextClick: () => void;
}

const QUESTION_TYPE_OPTIONS: SelectOption[] = [
  { id: 1, value: 'seen', content: 'Seen Questions' },
  { id: 2, value: 'unseen', content: 'Unseen Questions' },
  { id: 3, value: 'both', content: 'Both' },
];

export const UGEGSelectQuestionType: React.FC<UGEGSelectQuestionTypeProps> = ({
  titleLeftText,
  titleRightText,
  selectedQuestionType,
  onQuestionTypeChange,
  onNextClick,
}) => {
  return (
    <StyledDiv flexDirection="column">
      <StickyHeader>
        <Spacing marginBottom="lg">
          <Typography variant="textTitleMediumSurfaceVariant">
            Select Question Type
          </Typography>
        </Spacing>
        <Spacing marginTop="lg">
          <TitleText
            leftText={titleLeftText}
            seperatorIconName="circle"
            rightText={titleRightText}
          />
        </Spacing>
      </StickyHeader>

      <Spacing margin="lg none">
        <StyledDiv
          flexDirection="column"
          gap={4}
          background="--md-sys-color-surface-container-high"
          borderRadius="--rk-spacing-md"
          padding="var(--rk-spacing-lg)"
        >
          <Typography variant="textLabelLargePrimary">Question Type</Typography>

          <Select
            label="Select a question type"
            options={QUESTION_TYPE_OPTIONS}
            onChange={onQuestionTypeChange}
            defaultValue={selectedQuestionType?.value || null}
            width="100%"
          />

          <Typography variant="textBodySmallOnSurfaceVariant">
            Choose what type of questions you would like to include in your
            paper
          </Typography>
        </StyledDiv>
      </Spacing>

      <SubmitBtn>
        <Button
          data-cy="ug-eg-select-type-next-button"
          onClick={onNextClick}
          disabled={!selectedQuestionType}
        >
          Next
        </Button>
      </SubmitBtn>
    </StyledDiv>
  );
};

const StickyHeader = styled.div`
  padding: var(--rk-spacing-lg) var(--rk-spacing-sm);
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--md-sys-color-on-primary);
`;

const SubmitBtn = styled.div`
  width: -webkit-fill-available;
  padding: var(--rk-spacing-xxl) 0;
  background: var(--md-sys-color-on-primary);
  margin-right: var(--rk-spacing-xl);
  position: fixed;
  bottom: 0;
  ${mq(BreakpointSizes.xs)} {
    md-filled-button {
      width: 100%;
    }
  }
`;
